import * as Icon from 'react-feather'
export const Feather = Icon
